import { createActions } from '../../../../commons/utils';

export const SAVE_DOCUMENT_FORM = createActions('SAVE_DOCUMENT_FORM');
export const CLEAN_DOCUMENT_FORM = createActions('CLEAN_DOCUMENT_FORM');
